// extracted by mini-css-extract-plugin
module.exports = {"fadeIn":"layout-module--fadeIn--bMk49","opacityIn":"layout-module--opacityIn--2ZgOv"};